import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useMatches } from "react-router-dom";

export interface RouteMatch {
  id: string;
  pathname: string;
  data: any;
  params: Record<string, string>;
  handle?: {
    crumb: (match: RouteMatch) => CrumbData;
  };
}

export interface CrumbData extends RouteMatch {
  label: string;
}

const Breadcrumbs: React.FC = () => {
  const matches = useMatches() as RouteMatch[];

  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => match.handle!.crumb(match));

  const crumbsLength = crumbs?.length;
  if (crumbsLength < 2) {
    return null;
  }

  return (
    <>
      <MuiBreadcrumbs sx={{ pb: 1 }} separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return isLast ? (
            <Typography
              key={crumb.pathname}
              color="text.primary"
              variant={crumbsLength === 1 ? 'title' : 'h4'}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {crumb.label}
            </Typography>
          ) : (
            <Link
              component={RouterLink}
              to={crumb.pathname}
              key={crumb.pathname}
              color="inherit"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant={crumbsLength === 1 ? "title" : "h4"}>{crumb.label}</Typography>
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </>
  );
};

export default Breadcrumbs;